/**
 * URLs y tipos para gestionar suscripción según origen (MP vs tiendas).
 * Sin dependencias de React.
 *
 * Nota: no usar `process.env.EXPO_PUBLIC_*` con notación punto en `shared/` —
 * Metro lo reescribe a `expo/virtual/env` y falla al importar desde fuera de apps/vuelto-negocio.
 */

export type SubscriptionProvider = 'mercadopago' | 'apple' | 'google';

export const APPLE_MANAGE_SUBSCRIPTIONS_URL = 'https://apps.apple.com/account/subscriptions';
export const GOOGLE_PLAY_MANAGE_SUBSCRIPTIONS_URL = 'https://play.google.com/store/account/subscriptions';
export const MERCADO_PAGO_SUBSCRIPTIONS_URL = 'https://www.mercadopago.com.ar/subscriptions';

const defaultAppOrigin = 'https://app.vuelto.ar';

function readPublicEnv(key: string): string | undefined {
  const env = typeof process !== 'undefined' ? process.env : undefined;
  const value = env?.[key];
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

export function billingAppOrigin(): string {
  return (
    readPublicEnv('EXPO_PUBLIC_EXPO_WEB_APP_ORIGIN')?.replace(/\/$/, '') ||
    readPublicEnv('NEXT_PUBLIC_EXPO_WEB_APP_ORIGIN')?.replace(/\/$/, '') ||
    defaultAppOrigin
  );
}

export type BillingAppUrlOptions = {
  plan?: string;
  /** Abre Plan y facturación tras auth (`?billing=1`). */
  billing?: boolean;
  /** Código one-shot de handoff nativo → web. */
  handoffCode?: string;
};

/** URL de la app (billing) sin tokens SSO. */
export function billingAppUrl(planOrOptions?: string | BillingAppUrlOptions): string {
  const opts: BillingAppUrlOptions =
    typeof planOrOptions === 'string' ? { plan: planOrOptions } : planOrOptions ?? {};
  const base = billingAppOrigin();
  const search = new URLSearchParams();
  if (opts.plan) search.set('plan', opts.plan);
  if (opts.billing) search.set('billing', '1');
  if (opts.handoffCode) search.set('billing_handoff', opts.handoffCode);
  const qs = search.toString();
  return qs ? `${base}?${qs}` : base;
}

/** @deprecated Usar billingAppUrl — sin relay de tokens. */
export function planesWebUrl(
  _portalOrigin: string,
  _accessToken?: string,
  _refreshToken?: string,
  plan?: string,
): string {
  return billingAppUrl(plan ? { plan, billing: true } : { billing: true });
}
